import axios from 'axios'

const HttpClient = {
  create: () => {
    let client = axios.create()
    return client
  }
}

export default HttpClient